import React from 'react';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import { Card, CardText } from 'material-ui/Card';
import moment from 'moment';

export default class GroupedTranscriptions extends React.Component {
  state = {
    recordings: [],
  };
  componentDidMount() {
    if (this.props && this.props.location && this.props.location.state && this.props.location.state.recordings) {
      this.setState({ recordings: this.props.location.state.recordings });
    }
  }

  getRecordingOffset = (words, type) => {
    if(words.length > 0) {
      return parseInt(words[0]['startTime']['seconds']) 
    } else {
      return 0
    }
  }

  formatGoogleTranscription = (data, recording) => {
    data = data.map(d => {
      return {
        startOffset: parseInt(d.alternatives[0].words[0].startTime.seconds || d.alternatives[0].words[1].startTime.seconds),
        timestamp: moment(new Date(recording.recording_started_at * 1000)).add('seconds', this.getRecordingOffset(d.alternatives[0].words, 'start')).toDate(),
        transcript: d.alternatives[0].transcript
      }
    });
    return data;
  }

  render() {
    console.log(this.state.recordings);
    return (
      <Paper
        style={{
          padding: '30px',
          borderRadius: '5px',
          border: '1px solid #cecece',
          boxShadow: 'none',
          marginBottom: '16px',
        }}
      >
        <FlatButton
          onClick={() => this.props.history.goBack()}
          icon={<NavigationArrowBack color="#3659A0" style={{ marginLeft: 0 }} />}
          label="Back"
          labelStyle={{
            color: '#3659A0',
          }}
          style={{
            marginBottom: '5px',
          }}
        />
        <Card style={{ marginBottom: '10px', border: '1px solid #c2c2c2', boxShadow: 'none' }}>
          <CardText>
            {this.state.recordings.map((rec) => {
              let transcription = [], googleTranscription = [];
              if (rec.video_transcription) {
                let t = JSON.parse(rec.video_transcription);
                if(Array.isArray(t)) {
                  transcription = t;
                }
              }

              if(rec.google_stt) {
                let t = JSON.parse(rec.google_stt).results;
                if(Array.isArray(t)) {
                  googleTranscription = this.formatGoogleTranscription(t, rec);
                }
              }
              return (
                <div>
                  {transcription.length > 0 ? (
                    <div style={{ marginBottom: '5rem' }}>
                      <div className="separator">
                        {rec.channel_id.split('.')[1]} - {moment.unix(rec.recording_ended_at).format('YYYY-MM-DD HH:mm:ss')}
                      </div>
                      <h3>IMB Results</h3>
                      {transcription.map((d) => {
                        return (
                          <div style={{ marginBottom: '10px', lineHeight: '20px' }}>
                            <a
                              target="_blank"
                              href={rec? rec.s3_url + `#t=${d.startOffset}` : ''}
                              style={{ fontWeight: 'bold', marginRight: '6px' }}
                            >
                              {moment(d.timestamp).format('YYYY-MM-DD HH:mm:ss')}:
                            </a>
                            <span>{d.transcription}</span>
                          </div>
                        );
                      })}

                      {googleTranscription && googleTranscription.map(result => {
                        return (
                          <div style={{ marginBottom: '10px', lineHeight: '20px' }}>
                          <a
                              target="_blank"
                              href={this.state.recording ? this.state.recording.s3_url + `#t=${result.startOffset}` : ''}
                              style={{ fontWeight: 'bold', marginRight: '6px' }}
                            >
                              {moment(result.timestamp).format('YYYY-MM-DD HH:mm:ss')}:
                            </a>
                            <span>{result.transcript}</span>
                          </div>
                        );
                      })}
                      {googleTranscription.length === 0 && <h4>No transcriptions found!</h4>}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              );
            })}
          </CardText>
        </Card>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// src/routes/Transcriptions/GroupedTranscriptions.js